import React from 'react';

MultiPageSelector.defaultProps = {
  itemList: [],
  numberOfElements: 0,
  numberOfElementsOnAPage: 0,
  itemTypeName: 'items',
  allItemsAreSelected: false,
  setAllItemsAreSelected: (state) => {
    alert('Empty function');
  },
  // A list that keeps its selection across pages knows the real total, which the items of the
  // page currently loaded cannot tell. Left null the count is taken from the loaded page as before.
  numberOfSelectedItems: null,
  // Clearing a kept selection means more than dropping the "all items in the set" flag, so the
  // owner of the selection can take the clear button over.
  clearSelection: null,
};

export default function MultiPageSelector({
  itemList,
  numberOfElements,
  numberOfElementsOnAPage,
  itemTypeName,
  allItemsAreSelected,
  setAllItemsAreSelected,
  numberOfSelectedItems,
  clearSelection,
}) {
  const numberOfSelectedItemsOnPage = () => {
    return itemList.filter((item) => item.Selected).length;
  };

  const areAllItemsSelectedOnPage = () => {
    return itemList.find((i) => i.Selected === false) === undefined;
  };

  const clear = () => {
    if (clearSelection) {
      clearSelection();
      return;
    }
    setAllItemsAreSelected(false);
  };

  const selectionIsCounted = typeof numberOfSelectedItems === 'number';
  const numberOfSelected = selectionIsCounted ? numberOfSelectedItems : numberOfSelectedItemsOnPage();
  return areAllItemsSelectedOnPage() && numberOfElements > numberOfElementsOnAPage ? (
    <div className='bravo-ds'>
      {allItemsAreSelected ? (
        <div className='selbar-all'>
          All <b>{numberOfElements}</b> {itemTypeName} in this set are selected.
          <button onClick={clear}>Clear selection</button>
        </div>
      ) : (
        <div className='selbar-all'>
          {selectionIsCounted ? (
            <>
              <b>{numberOfSelected}</b> {itemTypeName} selected.
            </>
          ) : (
            <>
              All <b>{numberOfSelected}</b> on this page are selected.
            </>
          )}
          <button onClick={() => setAllItemsAreSelected(true)}>Select all {numberOfElements} in this set</button>
        </div>
      )}
    </div>
  ) : numberOfSelected > 0 ? (
    <div className='bravo-ds'>
      <div className='selbar-all'>
        <b>{numberOfSelected}</b> selected
        {clearSelection && <button onClick={clear}>Clear selection</button>}
      </div>
    </div>
  ) : null;
}
